// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Added v7 — see `ChannelModifier.schema_version`.
 *
 * What a BEFORE modifier does with the held source message when its gate fails:
 * the payload could not be delivered, or an expected step never arrived.
 *   `RELEASE` (0) — the default and the pre-v7 behavior: forward the source message
 *                   anyway. Fails open, so a dead device cannot strand the elevator.
 *   `DROP` (1)    — discard it and report an `AckOutcome.Withheld` verdict. Fails
 *                   closed, for gates that must not be bypassed. BEFORE only.
 */
export enum ModifierTimeoutPolicy {
  RELEASE = 0,
  DROP = 1,
}
